{
    "author_s_insight": "<0>{{name}}<\/0>'s insight:",
    "curated_by": "Curated by",
    "popular_tags": "Popular Tags",
    "powered_by": "Powered by",
    "studio_autodetect_browser_based": "Autodetect (browser based)",
    "studio_block_background_color": "Block background color\n",
    "studio_border": "Border",
    "studio_click_to_set": "Edit",
    "studio_click_to_set_border": "Edit",
    "studio_click_to_set_color": "Edit",
    "studio_code_copied": "Code copied!",
    "studio_copy_code_to_clipboard": "Copy code",
    "studio_curator_insight_background_color": "Curator insight background color",
    "studio_display_image_instead_of_media_video_embed": "Display image instead of media (video, embed)",
    "studio_display_powered_by_scoop_it": "Display \"Powered by Scoop.it\"",
    "studio_display_shadows": "Display shadows",
    "studio_embed_widget_type": "Embed widget type",
    "studio_filter_by_tag": "Filter by tag",
    "studio_language": "Language",
    "studio_links_color": "Links color",
    "studio_maximum_number_of_columns": "Maximum number of columns",
    "studio_maximum_number_of_posts": "Maximum number of posts",
    "studio_minimum_number_of_columns": "Minimum number of columns",
    "studio_post_section_content": "Content",
    "studio_post_section_insight": "Curator insight",
    "studio_post_section_media": "Media (image, video)",
    "studio_post_section_meta": "Site & date",
    "studio_post_section_title": "Title",
    "studio_posts_sections": "Sections",
    "studio_prevent_close": "Are you sure you want to leave this page? None of your changes will be persisted.",
    "studio_remove_border": "Remove border",
    "studio_remove_color": "Remove color",
    "studio_reset": "Reset",
    "studio_responsive_split_width": "Responsive split width",
    "studio_show_header": "Show header",
    "studio_show_paginator": "Display pagination",
    "studio_show_tags": "Display Tag Cloud",
    "studio_style_expl": "<p> If you do not set colors, default colors from the target page should be applied (eg: link color should be the same as link colors of the page you put the embed into.). <\/p> <p> Not choosing background colors, means backgrounds, will be left transparent. <\/p>",
    "studio_tag_cloud_max_tag_count": "Maximum number of tags",
    "studio_tag_cloud_title": "Tag cloud title",
    "studio_title_embed_code": "Embed Code",
    "studio_title_page": "Page",
    "studio_title_posts": "Posts",
    "studio_title_preview_your_embed": "Preview your embed",
    "studio_title_responsive_configuration": "Responsive configuration",
    "studio_title_styling": "Styling",
    "studio_type_carousel": "Carousel",
    "studio_type_minimalist_list": "Minimalist list",
    "studio_type_responsive_grid": "Responsive grid",
    "studio_use_publication_date": "Display publication date instead of curation date"
}